import styled from 'styled-components'

const UploadButtonIconUi = styled.i`
  font-size: 16px;
`

export default UploadButtonIconUi
